import { cn } from '@/libs';

type SupportContactProps = {
  /** `inline` is one centred row; `stacked` is a column. */
  layout: 'inline' | 'stacked';
};

/** GDS support, in display order. Fax has no link: a phone cannot use it. */
const CONTACTS: { label: string; text: string; href?: string }[] = [
  { label: 'Phone', text: '(866) 437-6968 ext. 2', href: 'tel:8664376968' },
  {
    label: 'Email',
    text: 'apps@servicesbygemini.com',
    href: 'mailto:apps@servicesbygemini.com',
  },
  { label: 'Fax', text: '(714) 782-5639' },
];

const listClassNames = {
  // At the app's mobile width the row stacks and drops its bullets.
  inline:
    'flex flex-wrap justify-center gap-x-5 gap-y-1 max-[768px]:flex-col max-[768px]:items-center',
  stacked: 'flex flex-col gap-2',
};

const itemClassNames = {
  inline:
    "before:mr-5 before:content-['•'] first:before:content-none max-[768px]:before:content-none",
  stacked: undefined,
};

const linkClassName =
  'text-primary-darkest underline underline-offset-2 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-darker';

/** The GDS support phone, email and fax, each with a bold label. */
export const SupportContact = ({ layout }: SupportContactProps) => (
  <ul
    aria-label="GDS support"
    className={cn(
      'font-nunito text-sm leading-normal text-neutral-darker',
      listClassNames[layout],
    )}
  >
    {CONTACTS.map(({ label, text, href }) => (
      <li key={label} className={itemClassNames[layout]}>
        <b className="font-bold">{label}:</b>{' '}
        {href ? (
          <a className={linkClassName} href={href}>
            {text}
          </a>
        ) : (
          <span>{text}</span>
        )}
      </li>
    ))}
  </ul>
);
